import { AttachmentCategory } from '@/modules/FarmProfile/types';
import { StateCreator } from 'zustand';

type View = AttachmentCategory | 'note' | 'plot' | 'action' | 'plan';

export type Attachment = {
  id: number;
  category: AttachmentCategory | 'note' | 'action' | 'plan';
};

export interface FarmProfileSlice {
  farmProfileView: View | null;
  setFarmProfileView: (tab: View) => void;
  clearFarmProfileView: () => void;
  attachment: Attachment | null;
  setAttachment: (attachment: Attachment) => void;
  clearAttachment: () => void;
  history: {
    view: View | null;
    attachment: Attachment | null;
  }[];
  clearHistory: () => void;
  navigateBack: (steps?: number) => void;
}

const historyInitialState = [
  {
    view: null,
    attachment: null,
  },
];

export const createFarmProfileSlice: StateCreator<FarmProfileSlice> = (
  set
) => ({
  farmProfileView: null,
  setFarmProfileView: (view) => {
    set((state) => {
      const lastEntry = state.history[state.history.length - 1];
      if (lastEntry.view === view) {
        return state;
      }
      return {
        farmProfileView: view,
        history: [
          ...state.history,
          { ...state.history[state.history.length - 1], view },
        ],
      };
    });
  },
  clearFarmProfileView: () => {
    set({
      farmProfileView: null,
      attachment: null,
      history: historyInitialState,
    });
  },
  attachment: null,
  setAttachment: (attachment) => {
    set((state) => {
      const lastEntry = state.history[state.history.length - 1];
      const isSameAttachment =
        lastEntry.attachment?.id === attachment.id &&
        lastEntry.attachment.category === attachment.category;
      return {
        attachment,
        farmProfileView: attachment.category,
        history: isSameAttachment
          ? state.history
          : [...state.history, { view: attachment.category, attachment }],
      };
    });
  },
  clearAttachment: () => {
    set({
      attachment: null,
    });
  },
  history: historyInitialState,
  clearHistory: () => {
    set({
      history: historyInitialState,
    });
  },
  navigateBack: (steps = 1) => {
    set((state) => {
      if (steps >= state.history.length - 1) {
        return {
          history: historyInitialState,
          farmProfileView: null,
          attachment: null,
        };
      }
      const newHistory = state.history.slice(0, steps * -1);
      const lastEntry = newHistory[newHistory.length - 1];
      return {
        history: newHistory,
        farmProfileView: lastEntry.view,
        attachment: lastEntry.attachment,
      };
    });
  },
});
